import { IMG_B0amp82UybsNZRk8whwTc } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabBreakIn() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'Siren',
      text: t('detail.break-in-siren')
    },
    {
      icon: 'HeadsetPerson',
      text: t('detail.break-in-agent-update')
    },
    {
      icon: 'PoliceCar',
      text: t('detail.break-in-police-dispatch')
    },
    {
      icon: 'ShieldCheck',
      text: t('detail.break-in-agent-interaction')
    }
  ] as const
  const disclaimers = [
    t('disclaimer.break-in-agent-interaction'),
    t('disclaimer.break-in-police-dispatch')
  ] as const
  return (
    <AlarmMomentsTab
      image={IMG_B0amp82UybsNZRk8whwTc}
      details={details}
      disclaimers={disclaimers}
      theme="dark"
    />
  )
}
